import { createFileRoute } from "@tanstack/react-router";
import AdminPartsMessageDetail from "@/pages/admin/AdminPartsMessageDetail";

export const Route = createFileRoute("/_adminLayout/admin/parts/messages/$id")({
  component: AdminPartsMessageDetail,
});
